// extracted by mini-css-extract-plugin
module.exports = {"iconHover":"Header_iconHover__1Z89H","dropDownText":"Header_dropDownText__2XZ_K"};